import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';

import { EmailConfirmationComponent } from './features/auth/email-confirmation/email-confirmation.component';
import { LoginComponent } from './features/auth/login/login.component';
import { RegisterComponent } from './features/auth/register/register.component';
import { LearnsetsViewComponent } from './features/learnsets-view/learnsets-view.component';
import { LearnsetViewComponent } from './features/learnset-view/learnset-view.component';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { CoursesViewComponent } from './features/courses-view/courses-view.component';
import { CourseViewComponent } from './features/course-view/course-view.component';
import { ForgotPasswordComponent } from './features/auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './features/auth/reset-password/reset-password.component';
import { OnboardingComponent } from './features/onboarding/onboarding.component';
import { SettingsViewComponent } from './features/settings-view/settings-view.component';
import { GetPremiumComponent } from './features/get-premium/get-premium.component';
import { PrivacyPolicyComponent } from './features/privacy-policy/privacy-policy.component';
import { CreateAiFlashcardsComponent } from './features/create/create-ai-flashcards/create-ai-flashcards.component';
import { LearnViewComponent } from './features/learn/learn-view/learn-view.component';
import { LearnQuestionAnswer } from './features/learn/learn-question-answer/learn-question-answer.component';
import { LearnWithAiComponent } from './features/learn/learn-with-ai/learn-with-ai.component';
import { CreateFlashcardsChatComponent } from './features/create/create-flashcards-chat/create-flashcards-chat.component';
import { CreateUploadFlashcardsComponent } from './features/create/create-upload-flashcards/create-upload-flashcards.component';
import { SubscriptionViewComponent } from './features/subscription-view/subscription-view.component';
import { TermsComponent } from './features/terms/terms.component';
import { ExamViewComponent } from './features/exam-view/exam-view.component';
import { ContactComponent } from './features/contact/contact.component';
import { LandingpageComponent } from './features/landingpage/landingpage.component';
import { SmartRepetitionComponent } from './features/smart-repetition/smart-repetition.component';
import { LearnAudioComponent } from './features/learn/learn-audio/learn-audio.component';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'demo', component: CreateAiFlashcardsComponent },
  { path: 'lp4', component: LandingpageComponent },
  { path: 'terms', component: TermsComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'login', component: LoginComponent },
  { path: 'verify-email', component: EmailConfirmationComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password/:token', component: ResetPasswordComponent },
  { path: 'onboarding', component: OnboardingComponent, canActivate: [AuthGuard] },
  { path: 'home', component: DashboardComponent, canActivate: [AuthGuard] },
  { path: 'smart-repetition', component: SmartRepetitionComponent, canActivate: [AuthGuard] },
  { path: 'courses', component: CoursesViewComponent, canActivate: [AuthGuard] },
  { path: 'courses/:id', component: CourseViewComponent, canActivate: [AuthGuard] },
  { path: 'courses/:courseId/exam/:examId', component: ExamViewComponent, canActivate: [AuthGuard] },
  { path: 'learnsets', component: LearnsetsViewComponent, canActivate: [AuthGuard] },
  { path: 'sets/:id/learn/classic-mode', component: LearnViewComponent, canActivate: [AuthGuard] },
  { path: 'sets/:id/learn/text-answer-mode', component: LearnQuestionAnswer, canActivate: [AuthGuard] },
  { path: 'sets/:id/learn/ai-chat', component: LearnWithAiComponent, canActivate: [AuthGuard] },
  { path: 'sets/:id/learn/audio-mode', component: LearnAudioComponent, canActivate: [AuthGuard] },
  { path: 'sets/:id/create/ai-old', component: CreateFlashcardsChatComponent, canActivate: [AuthGuard] },
  { path: 'sets/:id/create/ai', component: CreateUploadFlashcardsComponent, canActivate: [AuthGuard] },
  { path: 'sets/:id', component: LearnsetViewComponent, canActivate: [AuthGuard] },
  { path: 'settings', component: SettingsViewComponent, canActivate: [AuthGuard] },
  { path: 'get-premium', component: GetPremiumComponent, canActivate: [AuthGuard] },
  { path: 'contact', component: ContactComponent, canActivate: [AuthGuard] },
  { path: 'settings/subscription', component: SubscriptionViewComponent, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
